
import { useState } from 'react';
import { ModalCampaignQuestionFormData } from "@/types/modalCampaigns";

export const useQuestionManager = () => {
  const [questions, setQuestions] = useState<ModalCampaignQuestionFormData[]>([]);

  // Add new question
  const addQuestion = () => {
    setQuestions(prev => [
      ...prev, 
      {
        question_text: "",
        options: ["", ""],
        correct_options: [],
        points: 1,
        order_number: prev.length
      }
    ]);
  };
  
  // Update a question
  const updateQuestion = (index: number, updatedQuestion: ModalCampaignQuestionFormData) => {
    const newQuestions = [...questions];
    newQuestions[index] = updatedQuestion;
    setQuestions(newQuestions);
  };
  
  // Remove a question
  const removeQuestion = (index: number) => {
    setQuestions(prev => prev.filter((_, i) => i !== index));
  };
  
  // Handle AI generated questions
  const handleQuestionsGenerated = (generatedQuestions: ModalCampaignQuestionFormData[]) => {
    // Replace existing questions with generated ones if the user confirms
    if (questions.length > 0) {
      const confirmReplace = window.confirm('Wil je de bestaande vragen vervangen door de gegenereerde vragen?');
      if (confirmReplace) {
        setQuestions(generatedQuestions);
      } else {
        // Append the generated questions to the existing ones
        setQuestions(prev => [...prev, ...generatedQuestions]);
      }
    } else {
      // No existing questions, just set the generated ones
      setQuestions(generatedQuestions);
    }
  };

  return {
    questions,
    setQuestions,
    addQuestion,
    updateQuestion,
    removeQuestion,
    handleQuestionsGenerated,
  };
};
